import { DeleteRoomState, DeleteRoomActionTypes, DELETE_ROOM_REQUEST, DELETE_ROOM_SUCCESS, DELETE_ROOM_FAILURE } from "store/reducers/room/deleteRoom/types";

const defaultState: DeleteRoomState = {
  isLoading: false,
  errorMessage: ""
};

export default function deleteRoom(state = defaultState, action: DeleteRoomActionTypes): DeleteRoomState {
  switch (action.type) {
    case DELETE_ROOM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DELETE_ROOM_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case DELETE_ROOM_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};